module.exports = __webpack_public_path__ + "static/media/profile-illustration-min.fa87f4c4.png";